export default {"discountBadgeWrapper":"OtI3l"};